import Marquee from "react-fast-marquee";
import { Flame } from "lucide-react";
import { useLang } from "@/lib/i18n";

const ITEMS = [
    { fr: "Perte de gras", en: "Fat loss" },
    { fr: "Cuisine africaine", en: "African cuisine" },
    { fr: "Force & esprit", en: "Strength & mind" },
    { fr: "Coach Roméo", en: "Coach Roméo" },
    { fr: "Musculation", en: "Bodybuilding" },
    { fr: "Fierté culinaire", en: "Culinary pride" },
];

const EditorialMarquee = () => {
    const { tr } = useLang();
    return (
        <div className="border-y border-white/10 bg-obsidian-surface py-5 md:py-7 overflow-hidden" data-testid="editorial-marquee">
            <Marquee speed={35} gradient={false} pauseOnHover>
                {ITEMS.map((item) => (
                    <span key={item.fr} className="flex items-center gap-8 md:gap-12 mr-8 md:mr-12">
                        <span className="font-heading text-2xl md:text-4xl font-extrabold uppercase tracking-tight text-terracotta/70">
                            {tr(item)}
                        </span>
                        <Flame className="h-5 w-5 md:h-7 md:w-7 text-ochre/60" />
                    </span>
                ))}
            </Marquee>
        </div>
    );
};

export default EditorialMarquee;
